"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SourceItem;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const store_1 = require("../../store");
const document_1 = require("../../slices/document");
const AppText_1 = require("../../component/AppText");
const colors_1 = require("../../common/colors");
const IconOnSteroid_1 = __importDefault(require("../../component/IconOnSteroid"));
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_native_2 = require("react-native");
function SourceItem({ file, selected }) {
    const dispatch = (0, store_1.useAppDispatch)();
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const FileIcon = (0, react_1.useMemo)(() => {
        switch (file.type ?? file.sourceType) {
            case 'pdf':
                return { icon: pro_solid_svg_icons_1.faFileLines, gradientColors: ["#8B7BF5", "#6FA2FF"] };
            case 'csv':
                return { icon: pro_solid_svg_icons_1.faTable, gradientColors: ["#147F2C", "#B3B700"] };
            case 'web':
                return { icon: pro_solid_svg_icons_1.faLinkSimple, gradientColors: ["#7AAAF4", "#68DAC0"] };
            case 'txt':
                return { icon: pro_solid_svg_icons_1.faAlignLeft, gradientColors: ["#F45C06", "#FFA800"] };
            case 'youtube':
                return { icon: pro_solid_svg_icons_1.faVideo, gradientColors: ["#B31217", "#F3017E"] };
            default:
                return { icon: pro_solid_svg_icons_1.faFileLines, gradientColors: ["#8B7BF5", "#6FA2FF"] };
        }
    }, [file]);
    const handleFollowUrl = (0, react_1.useCallback)(() => {
        react_native_1.Linking.openURL(file.sourceUrl || file.urlPath);
    }, [file]);
    const handleSelect = (0, react_1.useCallback)((checked) => {
        if (checked) {
            dispatch((0, document_1.selectFiles)(file));
        }
        else {
            dispatch((0, document_1.unSelectedFile)(file));
        }
    }, [file, dispatch]);
    return ((0, jsx_runtime_1.jsxs)(react_native_2.Pressable, { onPress: handleFollowUrl, onPointerEnter: () => setIsHovered(true), onPointerLeave: () => setIsHovered(false), style: [
            styles.container,
            isHovered && styles.hoveredContainer
        ], children: [selected !== undefined && ((0, jsx_runtime_1.jsx)(react_native_2.Pressable, { style: styles.checkboxContainer, children: (0, jsx_runtime_1.jsx)(native_base_1.Checkbox, { value: "", isChecked: selected, onChange: handleSelect, colorScheme: "white", _checked: {
                        backgroundColor: colors_1.Colors.PRIMARY_700,
                        borderColor: colors_1.Colors.PRIMARY_700,
                    }, _icon: {
                        color: colors_1.Colors.white
                    } }) })), (0, jsx_runtime_1.jsx)(IconOnSteroid_1.default, { icon: FileIcon.icon, size: 22, gradientColors: FileIcon.gradientColors }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.text, noOfLines: 1, children: (() => {
                    switch (file.type || file.sourceType) {
                        case 'web':
                            return file.sourceUrl.replace(/^https?:\/\//, '');
                        case 'youtube':
                            return file.sourceUrl;
                        default:
                            return file.fileName.replace(/\.pdf$/, '');
                    }
                })() }), (0, jsx_runtime_1.jsx)(IconOnSteroid_1.default, { icon: pro_solid_svg_icons_1.faArrowUpRightFromSquare, size: 16, gradientColors: isHovered ? ['#FFFFFF', '#FFFFFF'] : ['rgba(255, 255, 255, 0.56)', 'rgba(255, 255, 255, 0.56)'] })] }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        backgroundColor: `${colors_1.Colors.NEUTRAL_50}3D`,
        flexDirection: 'row',
        alignItems: 'center',
        padding: 16,
        gap: 4,
        borderRadius: 8,
    },
    hoveredContainer: {
        backgroundColor: `${colors_1.Colors.NEUTRAL_50}66`,
    },
    checkboxContainer: {
        backgroundColor: `${colors_1.Colors.NEUTRAL_00}15`,
        borderRadius: 4,
        padding: 4,
        marginRight: 8,
        justifyContent: 'center',
        alignItems: 'center',
        // Ensure the checkbox container does not trigger parent's onPress
        // pointerEvents: 'auto' is default, but since this isn't inside
        // the Pressable, no need to stop propagation explicitly here.
    },
    linkArea: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
        gap: 16,
    },
    text: {
        color: colors_1.Colors.NEUTRAL_00,
        flex: 1,
    },
});
